export interface DynamicFilterItem {
  column_name: string
  operator: 'in' | 'is_null'
  values?: string[]
}

/**
 * Serializes dynamic column filter state into JSON string expected by backend API.
 * Maps values to 'in' operator and '__empty__' to 'is_null' operator.
 */
export function serializeDynamicFilters(
  dynamicFilters?: Record<string, string[]>
): string | undefined {
  if (!dynamicFilters || Object.keys(dynamicFilters).length === 0) {
    return undefined
  }

  const parsedFilters: DynamicFilterItem[] = []
  Object.entries(dynamicFilters).forEach(([columnName, values]) => {
    if (!values || values.length === 0) return

    const hasEmpty = values.includes('__empty__')
    const realValues = values.filter((v) => v !== '__empty__')

    if (realValues.length > 0) {
      parsedFilters.push({ column_name: columnName, operator: 'in', values: realValues })
    }
    if (hasEmpty) {
      parsedFilters.push({ column_name: columnName, operator: 'is_null' })
    }
  })

  return parsedFilters.length > 0 ? JSON.stringify(parsedFilters) : undefined
}

/**
 * Formats a column option value using either an explicit formatter function
 * or the column definition's valueFormatter. Falls back to raw value.
 */
export function formatColumnOption(
  colDef?: any,
  opt?: string,
  customFormatter?: (val: string) => string
): string {
  if (!opt || opt === '__empty__') return opt || ''
  if (customFormatter) return customFormatter(opt)
  if (colDef?.valueFormatter) {
    try {
      const res = (colDef.valueFormatter as any)(opt)
      if (typeof res === 'string') return res
      const resObj = (colDef.valueFormatter as any)({ value: opt })
      if (typeof resObj === 'string') return resObj
    } catch {
      return opt
    }
  }
  return opt
}

